var marketoID = '228-GPV-835'

var config = {
	munchkinId: marketoID,
	podId: `https://${marketoID}.mktoweb.com`,
}

var formsPool = []
var isLoading = false

var eventList = [
	'blur',
	'focus',
	'focusin',
	'focusout',
	'click',
	'change',
	'input',
	'select',
	'keydown',
	'keypress',
	'keyup',
]

function loadLibrary(onLoad) {
	var htmlElement = document.createElement('script')
	htmlElement.src = config.podId + '/js/forms2/js/forms2.min.js'
	htmlElement.async = true

	document.head.insertBefore(htmlElement, document.head.childNodes[0])

	htmlElement.onload = function () {
		if (typeof onLoad === 'function') {
			onLoad()
		}
	}
}

function processFormsPool() {
	if (isLoading) {
		return
	}

	var form = formsPool.shift()

	if (!form) {
		return
	}

	var formId = form.dataset.formId

	form.setAttribute('id', 'mktoForm_' + formId) //set the form id so Marketo knows where to render the form

	isLoading = true

	MktoForms2.loadForm(config.podId, config.munchkinId, formId, function (mktoForm) {
		var formElement = mktoForm.getFormElem()[0]
		var fieldDescriptors = Array.prototype.slice.call(formElement.querySelectorAll('.mktoFieldDescriptor'))
		var formSection = formElement.closest('.com-el-marketo-form')
		var formData = {}

		/* Setting values up for the experts library */
		if (mktoForm.getId() === 1081 && typeof mktoForm.getValues().expertId !== 'undefined' && typeof mktoForm.getValues().expertName !== 'undefined') {
			mktoForm.setValues({
				expertId: formSection.dataset.expertId,
				expertName: formSection.dataset.expertName
			})
		}

		form.id = ''
		isLoading = false
		formsPool.length && processFormsPool()

		var MktoWatcher = (function (fieldDescriptor) {
			var _interface = {
				formElementWrappers: [],
				validate: function () {
					_interface.formElementWrappers.forEach(function (formElement) {
						if (formElement.isInvalid().isInvalid) {
							formElement.displayError(formElement.isInvalid().message)
						} else {
							formElement.hideError()
						}
					})
				},
				addListeners: function () {
					_interface.formElementWrappers.forEach(function (formElement) {
						eventList.forEach(function (event) {
							formElement.element.addEventListener(event, function () {
								if (formElement.isInvalid().isInvalid) {
									formElement.displayError(formElement.isInvalid().message)
								} else {
									formElement.hideError()
								}
							})
						})
					})
				},
				init: function (fieldDescriptor) {
					fieldDescriptor
						.map(function (descriptor) {
							return MktoForms2.$(descriptor).data('mktoFieldDescriptor')
						})
						.filter(function (descriptor) {
							return descriptor.validationMessage !== undefined
						})
						.forEach(function (descriptor) {
							var data = {
								descriptor: descriptor,
								element: descriptor.validatorElem[0],
								validationMessage: descriptor.validationMessage,
								errorWrapper: null,
								isError: false,
								validator: descriptor.validator ? descriptor.validator : undefined,
								isEmailField: function () {
									return this.element.classList.contains('mktoEmailField')
								},
								displayError: function (errorMessage) {
									this.errorWrapper.style.display = ''
									this.errorWrapper.innerHTML = errorMessage
								},
								hideError: function () {
									this.errorWrapper.style.display = 'none'
								},
								isInvalid: function () {
									return {
										isInvalid: this.element.classList.contains('mktoInvalid'),
										message: this.validationMessage,
									}
								},
								init: function () {
									this.errorWrapper = document.createElement('div')
									this.errorWrapper.classList.add('com-el-marketo-form__error-message')
									this.errorWrapper.style.display = 'none'
									this.element.after(this.errorWrapper)

									return this
								},
							}

							_interface.formElementWrappers.push(data.init())
						})
				},
			}

			_interface.init(fieldDescriptor)
			_interface.addListeners()

			return _interface
		})(fieldDescriptors)

		if (formSection) {
			var preloader = formSection.querySelector('.com-el-marketo-form__preloader')
			var container = formSection.querySelector('.com-el-marketo-form__container')
			var submittedMessage = formSection.querySelector('.com-el-marketo-form__submitted-message')
			var buttonDescription = formSection.querySelector('.com-el-marketo-form__button-description')

			mktoForm.onValidate(function () {
				MktoWatcher.validate()
			})

			mktoForm.onSubmit(function () {
				preloader.classList.remove('is-hidden')
				container.classList.add('is-submitting')
			})

			mktoForm.onSuccess(function (data, followUpUrl) {
				var _form = form.closest('.com-el-marketo-form__form')
				var currentUrl = window.location.origin + window.location.pathname
				var _followUpUrl = new URL(followUpUrl)
				var parsedFollowUpUrl = _followUpUrl.origin + _followUpUrl.pathname

				if (_form) {
					_form.remove()
				}

				form.remove()
				preloader.remove()
				container.classList.remove('is-submitting')
				container.classList.add('is-submitted')

				if (submittedMessage) {
					submittedMessage.classList.remove('is-hidden')
				}

				if (buttonDescription) {
					buttonDescription.remove()
				}

				/* Displaying custom submitted message and sending custom event for Experts */
				if (formId === '1081') {
					var expertsHead = document.querySelector('.js-experts-head')
					var expertsSubmittedMessage = document.querySelector('.js-experts-submitted-message')

					formData.event = 'experts-form-marketo'

					expertsHead.remove()
					expertsSubmittedMessage.classList.remove('is-hidden')
				} else {
					formData.event = 'marketo_form_submitted'
				}

				formData.form_id = formId
				formData.form_data = data

				if (typeof window.dataLayer !== 'undefined') {
					window.dataLayer.push(formData)
				}

				if (currentUrl !== parsedFollowUpUrl) {
					window.open(followUpUrl, followUpUrl.startsWith('https://miro.com/') ? '_self' : '_blank')
				}

				return false
			})
		}
	})

	MktoForms2.whenReady(function (mktoForm) {
		var id = getRandomId()
		var forms = mktoForm.getFormElem()
		var baseStyle = document.querySelector('#mktoForms2BaseStyle')
		var themeStyle = document.querySelector('#mktoForms2ThemeStyle')
		var inlineStyles = document.querySelectorAll('head style')

		if (baseStyle && themeStyle) {
			baseStyle.remove()
			themeStyle.remove()
		}

		inlineStyles.forEach(function (inlineStyle, index) {
			if (inlineStyle.innerText.includes('mkto') && inlineStyles.length - 1 === index) {
				inlineStyle.remove()
			}
		})
		;[].forEach.call(forms, function (form) {
			var formSection = form.closest('.com-el-marketo-form')

			if (formSection) {
				var preloader = formSection.querySelector('.com-el-marketo-form__preloader')
				var buttonDescription = formSection.querySelector('.com-el-marketo-form__button-description')
				var styledElements = form.querySelectorAll('[style]')
				var formStyles = form.querySelectorAll('style')
				var unusableTags = form.querySelectorAll('.mktoAsterix, .mktoGutter, .mktoOffset, .mktoClear')
				var tags = form.querySelectorAll('h1, h2, h3, h4, h5, h6, p')
				var checkboxList = form.querySelectorAll('.mktoCheckboxList')
				var elements = formSection.querySelector('.com-el-marketo-form__elements')
				var labels = form.querySelectorAll('label[for]')

				form.removeAttribute('style')

				styledElements.forEach(function (styledElement) {
					if (!styledElement.classList.contains('com-el-marketo-form__error-message')) {
						styledElement.removeAttribute('style')
					}
				})

				formStyles.forEach(function (formStyle) {
					formStyle.remove()
				})

				unusableTags.forEach(function (unusableTag) {
					unusableTag.remove()
				})

				tags.forEach(function (tag) {
					if (tag.tagName === 'P') {
						tag.classList.add('com-el-content', 'com-el-content--small')
					} else if (tag.tagName === 'H1') {
						tag.classList.add('com-el-headline', 'com-el-headline--mid')
					} else {
						tag.classList.add('com-el-headline', 'com-el-headline--tiny')
					}
				})

				if (elements) {
					elements.classList.remove('is-hidden')

					if (elements.classList.contains('is-inner-elements')) {
						form.insertBefore(elements, form.childNodes[0])
					}
				}

				labels.forEach(function (label) {
					var forEl = form.querySelector('[id="' + label.htmlFor + '"]')

					if (forEl) {
						label.htmlFor = forEl.id = forEl.id + id
					}
				})

				checkboxList.forEach(function (list) {
					var checkboxes = list.querySelectorAll('[type="checkbox"]')

					if (checkboxes.length === 1) {
						var mainLabel = checkboxes[0].closest('.mktoFieldWrap').querySelector('.mktoLabel')
						var innerLabel = checkboxes[0].nextSibling

						if (innerLabel && mainLabel) {
							innerLabel.setAttribute('for', mainLabel.getAttribute('for'))
							innerLabel.innerText = mainLabel.innerText
							mainLabel.remove()
						}
					}
				})

				form.classList.add('is-loaded')
				preloader.classList.add('is-hidden')

				if (buttonDescription) {
					buttonDescription.classList.remove('is-hidden')
				}
			}
		})
	})
}

function loadMarketoForms(element) {
	if (!element) {
		return
	}

	if (typeof MktoForms2 === 'undefined') {
		loadLibrary(function () {
			loadMarketoForms(element)
		})

		return
	}

	var containerEl = element.querySelector('[data-container-id]')

	if (!containerEl) {
		console.warning('Missing data-container-id attribute in marketo container')
		return
	}

	var formId = containerEl.dataset.containerId

	if (!formId) {
		console.warning('Missing data-container-id attribute in market container')
		return
	}

	var formContainer = containerEl.querySelector('.com-el-marketo-form__form')

	// clear old form element
	if (formContainer) {
		formContainer.innerHTML = ''
	}

	var formEl = document.createElement('form') //create form element
	formEl.dataset.formId = formId

	if (formContainer) {
		formContainer.append(formEl) //add form
	}

	formsPool.push(formEl)

	processFormsPool()
}

function getRandomId() {
	return 'marketo-' + Math.random().toString(36).substr(2, 9)
}

var mktoContainers = document.querySelectorAll('.mkto-container')

mktoContainers.forEach(function (mktoContainer) {
	loadMarketoForms(mktoContainer)
})
